import { of } from 'rxjs'
import { tap, pluck, filter, map } from 'rxjs/operators'
import { APP_MODAL_OPEN, TRIAL_TO_BASIC } from '@/components/Modal/Enum'

export const verifyTrialToBasic = emit => notifications => {
  emit = emit(APP_MODAL_OPEN)
  of(notifications)
    .pipe(
      pluck('trialExpired'),
      filter(trialExpired => trialExpired),
      map(trialExpired => ({
        modal: TRIAL_TO_BASIC,
        payload: trialExpired,
      })),
      tap(emit)
    )
    .subscribe()
}
